var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6123 13.632C33.6801 4.54401 36.2121 0 40 0C43.7879 0 46.3198 4.54401 51.3877 13.632L52.6997 15.984C54.1397 18.5681 54.8596 19.8601 55.9796 20.7121C57.0996 21.5641 58.4996 21.8801 61.2995 22.5121L63.8434 23.0881C73.6832 25.3161 78.5991 26.4281 79.7711 30.1921C80.939 33.9521 77.5871 37.8761 70.8793 45.7201L69.1433 47.7481C67.2393 49.9762 66.2834 51.0922 65.8554 52.4682C65.4274 53.8482 65.5714 55.3362 65.8594 58.3082L66.1234 61.0162C67.1354 71.4842 67.6433 76.7162 64.5794 79.0402C61.5155 81.3683 56.9076 79.2442 47.6998 75.0042L45.3119 73.9082C42.6959 72.7002 41.388 72.1002 40 72.1002C38.612 72.1002 37.3041 72.7002 34.6841 73.9082L32.3042 75.0042C23.0924 79.2442 18.4845 81.3643 15.4246 79.0442C12.3566 76.7162 12.8646 71.4842 13.8766 61.0162L14.1406 58.3122C14.4286 55.3362 14.5726 53.8482 14.1406 52.4722C13.7166 51.0922 12.7606 49.9762 10.8567 47.7521L9.12073 45.7201C2.41288 37.8801 -0.939038 33.9561 0.228935 30.1921C1.40091 26.4281 6.32079 25.3121 16.1606 23.0881L18.7045 22.5121C21.5004 21.8801 22.8964 21.5641 24.0204 20.7121C25.1403 19.8601 25.8603 18.5681 27.3003 15.984L28.6123 13.632Z",
    fill: "#FE8F01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFill);
export default __webpack_public_path__ + "static/media/star-fill.0748aedb049973747ced7cb35ec9b1f2.svg";
export { ForwardRef as ReactComponent };